import React, {useEffect, useState} from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckIcon from '@material-ui/icons/Check';
import {Checkbox, Grid, Typography} from '@deere/fuel-react';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import {useAuthConfig} from "../helper";
import {useStyles} from "../styles/Filter";

const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

export const PersonFilter = ({selectedCreators, expanded, onSelectOwner, onExpandClick, title}) => {
    let authAxios = useAuthConfig();
    const classes = useStyles();
    const [userOwnerList, setUserOwnerList] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    const handleChangeValues = (event, value) => {
        sessionStorage.setItem("selectedCreators", JSON.stringify(value));
        setSelectedOptions(value);
        onSelectOwner(value);
    }

    const getOwnersList = async () => {
        try {
            return await authAxios.get(`/campaign/owners`);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        setSelectedOptions((sessionStorage["selectedCreators"] && JSON.parse(sessionStorage["selectedCreators"]).length > 0 && JSON.parse(sessionStorage["selectedCreators"])[0].createdBy) ? JSON.parse(sessionStorage.getItem("selectedCreators")) : selectedCreators);
        getOwnersList().then(res => {
            res && setUserOwnerList(res.data);
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCreators]);

    return (
        <div className={classes.root}>
            <Accordion expanded={expanded === "owner"}
                       onChange={onExpandClick("owner")}>
                <AccordionSummary
                    className={classes.accordionSummary}
                    classes={{content: classes.content, expanded: classes.expanded}}
                    expandIcon={<ExpandMoreIcon style={{fontSize: '2rem'}}/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography>{title}</Typography>
                        </Grid>
                        {!expanded && (
                            <Grid item xs={12}>
                                {selectedOptions.length > 0 && selectedOptions[0].createdBy && selectedOptions.map((data, index) => {
                                    return (
                                        <React.Fragment key={index}>
                                            <CheckIcon style={{color: "#367c2b", marginRight: "1rem"}}
                                                       display="inline"/>
                                            <Typography
                                                display="inline"
                                                key={data.createdBy}>{data.campaignOwner}</Typography>
                                            <br/>
                                        </React.Fragment>)
                                })
                                }
                            </Grid>
                        )}
                    </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.root}>
                    <Autocomplete
                        multiple
                        size="small"
                        id="owners"
                        options={userOwnerList}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.campaignOwner}
                        getOptionSelected={(option, value) => option.createdBy === value.createdBy}
                        value={selectedOptions}
                        onChange={handleChangeValues}
                        className={classes.root}
                        renderOption={(option, {selected}) => (
                            <React.Fragment>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{marginRight: 8}}
                                    checked={selected}
                                />
                                {option.campaignOwner}
                            </React.Fragment>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} variant="outlined" label={`Select created by`}/>
                        )}
                    />
                </AccordionDetails>
            </Accordion>
        </div>
    );
};
